const actionCodeSettings = {
    //url: 'https://www.example.com/?email=' + firebase.auth().currentUser.email,
    // iOS: {
    //   bundleId: 'com.example.ios'
    // },
    // android: {
    //   packageName: 'com.example.android',
    //   installApp: true,
    //   minimumVersion: '12'
    // },
    handleCodeInApp: false,
    // When multiple custom dynamic link domains are defined, specify which
    // one to use.
    //dynamicLinkDomain: "example.page.link"
};


export default actionCodeSettings;